const state = {
  waybillInfo: [],
  status: ''
}
const actions = {
  updateData (ctx, item) {
    ctx.commit('updateData', item)
  }
}
const mutations = {
  updateData (state, item) {
    state.waybillInfo = item
  },
  changeStatus (state, item) {
    state.status = item
  }
}
export default{
  namespaced: true,
  state,
  actions,
  mutations
}
